import React, { useContext } from "react";
import { SectionsContext } from "../context/SectionsContext";
import { AttempsContext } from "../context/AttemptsContext";
import { CoursesContext } from "../context/CoursesContext";
import QuizFailed from "./QuizFailed";
import QuizApproved from "./QuizApproved";
import QuizGrading from "./QuizGrading";
import QuizFeedback from "./QuizFeedback";
import "../css/SingleCurso.css";
import "../css/quiz.css";

const QuizResult = () => {
  const { course } = useContext(CoursesContext);
  const { section } = useContext(SectionsContext);
  const { questions, answers, attempt, test } = useContext(AttempsContext);

  const isAttemptValid = () => attempt && attempt !== null;

  const isTestValid = () => test && test !== null;

  const isCourseValid = () => course && course !== null;

  const renderStatus = () => {
    if (isAttemptValid() && isTestValid()) {
      if (attempt.score === null) {
        return <QuizGrading />;
      }
      if (parseFloat(attempt.score) >= parseFloat(test.min_score)) {
        return (
          <QuizApproved
            test={test}
            course={course}
            attempt={attempt}
          />
        );
      }
      return (
        <QuizFailed
          attempt={attempt}
          course={course}
          test={test}
        />
      );
    }
  };

  const renderFeedback = () => {
    if (isAttemptValid() && questions && questions.length > 0) {
      return (
        <div className="col-12 ps-5 px-5 mb-5 d-flex flex-column align-items-center">
          <QuizFeedback questions={questions} answers={answers} />
        </div>
      );
    }
  };

  const renderSection = () => {
    if (section && section !== null) {
      return (
        <div>
          <div className="h2 text-white">{section.name}</div>
          <div className="small text-white">{section.description}</div>
        </div>
      );
    }
  };

  const renderCourse = () => {
    if (isCourseValid()) {
      return course.name;
    }
    if (isAttemptValid()) {
      if (attempt.test && attempt.test !== null) {
        if (attempt.test.course && attempt.test.course !== null) {
          return attempt.test.course.name;
        }
      }
    }
    return "Certificación";
  };

  return (
    <div className="d-flex flex-column flex-grow-1 w-100 bg-accent px-lg-5 ps-lg-5">
      <div className="ps-5 px-5 d-flex flex-column flex-grow-1 justify-content-center align-items-center py-4">
        <div className="mt-5 display-5">{renderCourse()}</div>
        <div className="h2">{renderSection()}</div>
        <div className="shadow bg-white text-dark col-12 d-flex flex-column justify-content-center align-items-center mt-4 mb-5">
          {renderStatus()}
          {renderFeedback()}
        </div>
      </div>
    </div>
  );
};

export default QuizResult;
